import { User } from "oidc-client-ts";

// Core role definitions - ESSENTIAL
export const AppRole = {
  SCRM_APP_ADMIN: "!App-SCRM-Admin",
  SCRM_APP_READ_ONLY: "!App-SCRM-ReadOnly",
} as const;

export type AppRole = (typeof AppRole)[keyof typeof AppRole];

// Keep only if used elsewhere in your app
export const All_APP_ROLES = Object.values(AppRole);

export const ScrmAdminRole = [AppRole.SCRM_APP_ADMIN];
export const ScrmUserRole = [AppRole.SCRM_APP_READ_ONLY];

// Helper functions for role extraction - ESSENTIAL
const roleLookupMap = Object.values(AppRole).reduce<Record<string, AppRole>>(
  (acc, value) => {
    acc[value] = value;
    return acc;
  },
  {},
);

const lookupAppRole = (role?: string): AppRole | undefined => {
  if (!role) return undefined;
  return roleLookupMap[role];
};

// Main function to extract roles from OIDC user - ESSENTIAL
export const getAppRoles = (user: User): AppRole[] => {
  const rolesList: string[] = (user.profile.appRoles as string[]) ?? [];
  return rolesList.map(lookupAppRole).filter((role) => role !== undefined);
};

// Role validation utilities
export const isValidAppRole = (role: string): role is AppRole => {
  return Object.values(AppRole).includes(role as AppRole);
};
